'use strict';

export default {
  devStoreConfig: false,
  api: {
    default: 'https://secret-cove-67646.herokuapp.com/v0',
  },
  features: {
    Ledger: false,
    BTC: false,
    BOT: false,
    Ebay: false,
    balanceSelling: false,
  }
};



// WEBPACK FOOTER //
// ./config/config.client4.js